/**
 * Format the display label for a text-frame overlay group.
 *
 * When a group is nested under an ImageFrame, `groupName` alone is ambiguous —
 * two frames may both have a "Logo" group. We surface the owning frame name
 * inline so the customer can disambiguate without nesting/indent: nested
 * overlays render "GroupName (FrameName)", standalone overlays keep the bare
 * groupName.
 */
export function formatTextFrameGroupLabel(
    groupName: string | null | undefined,
    imageFrameName?: string | null,
): string {
    const safeGroup = (groupName ?? '').trim();
    const safeFrame = (imageFrameName ?? '').trim();
    if (!safeFrame) return safeGroup;
    if (!safeGroup) return safeFrame;
    return `${safeGroup} (${safeFrame})`;
}
